export enum TradeLayout {
  DEFAULT = "1",
  ORDERBOOK_LEFT = "2",
  ORDER_FORM_LEFT = "3",
  COMPACT_LEFT = "4",
  // ORDERBOOK_REFACTOR = "5", // Requires orderbook refactor — not yet available
  CHART_FULL = "6",
}

export const TRADE_LAYOUT_COOKIE = "trade-layout";
export const DEFAULT_TRADE_LAYOUT = TradeLayout.DEFAULT;

/** All layouts visible in the selection modal (Layout 5 excluded) */
export const VISIBLE_LAYOUTS = [
  TradeLayout.DEFAULT,
  TradeLayout.ORDERBOOK_LEFT,
  TradeLayout.ORDER_FORM_LEFT,
  TradeLayout.COMPACT_LEFT,
  TradeLayout.CHART_FULL,
] as const;

const validValues: string[] = [
  TradeLayout.DEFAULT,
  TradeLayout.ORDERBOOK_LEFT,
  TradeLayout.ORDER_FORM_LEFT,
  TradeLayout.COMPACT_LEFT,
  TradeLayout.CHART_FULL,
];

export function isValidTradeLayout(value: unknown): value is TradeLayout {
  return typeof value === "string" && validValues.includes(value);
}
